import React from 'react'
import { TextField } from '@boltenergy-be/design-system'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'next-i18next/pages'
import { InputProps } from 'components/inputs/types'
import { getFieldError, getFieldName } from 'components/inputs/utils'

const CompanyName = ({ required = true, identifier = 'companyName', parentDotPath }: InputProps) => {
  // React Hook Form
  const {
    formState: { errors },
    register
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation', 'common'])

  // Constants
  const fieldKey = getFieldName(identifier, parentDotPath)
  const fieldError = getFieldError(identifier, parentDotPath, errors)

  return (
    <TextField
      {...register(fieldKey, {
        maxLength: {
          value: 100,
          message: t(($) => $.max.string, {
            attribute: t(($) => $.companyName.label),
            length: 100,
            ns: 'validation'
          })
        },
        minLength: {
          value: 2,
          message: t(($) => $.min.string, {
            attribute: t(($) => $.companyName.label),
            length: 2,
            ns: 'validation'
          })
        },
        required: required ? t(($) => $.required, { ns: 'validation' }) : false
      })}
      error={fieldError?.message}
      label={t(($) => $.companyName.label)}
      {...(!required && { optionalText: t(($) => $.optional, { ns: 'common' }) })}
    />
  )
}

export default CompanyName
